var render = function render(){var _vm=this,_c=_vm._self._c;return _c('news-list',{attrs:{"noticeClass":_vm.noticeClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }